import React, { memo } from "react"
import Link from "next/link"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Navigation } from "swiper"
import CardLeague from "components/CardLeague"

// eslint-disable-next-line react/display-name
const MySwiper = memo((props) => {
  const { leagues, name } = props
  // console.log({ props })
  return (
    <div className="mb-4 md:mb-4 lg:mb-6 ">
      <div>
        <div className="relative wapper__swiper__custom">
          <h2 className="relative mb-2 md:mb-2 text-sm md:text-lg lg:text-xl font-semibold ">
            <Link href={`/league`}>
              <div className="text-dark-100 flex items-center wapper_see_more">
                <span className="uppercase mr-4">{name}</span>{" "}
                <div className="text-primary-500 text-sm flex items-center see_more">
                  <span>Xem thêm</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13 17L18 12L13 7"
                      stroke="#66A7FF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6 17L11 12L6 7"
                      stroke="#66A7FF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </Link>
          </h2>
          <Swiper
            key="league_vod"
            spaceBetween={16}
            modules={[Navigation]}
            className="swiper__luague"
            navigation={true}
            breakpoints={{
              1: {
                slidesPerView: 4.6,
                slidesPerGroup: 4
              },
              768: {
                slidesPerView: 6.5,
                slidesPerGroup: 6
              },
              890: {
                slidesPerView: 7.5,
                slidesPerGroup: 7
              },
              1050: {
                slidesPerView: 8.5,
                slidesPerGroup: 8
              },
              1280: {
                slidesPerView: 10.7,
                slidesPerGroup: 10
              }
            }}
          >
            {leagues?.length > 0 &&
              leagues?.map((item) => {
                const { id } = item
                return (
                  <SwiperSlide key={id}>
                    <CardLeague {...item} />
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </div>
      </div>
    </div>
  )
})

export default MySwiper
